import StatsCard from "@/components/dashboard/stats-card";
import PageWrapper from "@/components/layout/page-wrapper";
import LeadsCollection from "@/components/leads/leads-collection/leads-collection";
import LeadsHeader from "@/components/leads/leads-header/leads-header";
import LeadsTable from "@/components/leads/leads-table/leads-table";
import LeadsSearchHeader from "@/components/leads/leads-search-header/leads-search-header";
import { cn } from "@/lib/utils";
import useGlobalPermission from "@/store/user-permissions";
import { LogOut, MailCheck } from "lucide-react";
import { useState } from "react";
import { Card } from "@/components/ui/card";

const Leads = () => {
    const [totalLeads, setTotalLeads] = useState(0);

    const { permissionList } = useGlobalPermission();
    const leadsPermission = permissionList.find((item) => item.module.name === "Leads");

    return (
        <PageWrapper pageTitle="Leads" currentPage="Leads">
            <div className="mt-4 grid grid-cols-3 gap-4 md:grid-cols-4 lg:grid-cols-3">
                <div className="col-span-3 md:col-span-4 lg:col-span-3">
                    <>
                        <LeadsHeader />
                    </>
                </div>

                <>
                    <div className="col-span-3 md:col-span-4 lg:col-span-1">
                        <LeadsCollection />
                    </div>
                </>
                <div className="col-span-3 md:col-span-2 lg:col-span-1">
                    <StatsCard
                        value={!leadsPermission?.can_get_list ? -1 : totalLeads}
                        title="Leads Collected"
                        subtitle={!leadsPermission?.can_get_list ? "No permission to view" : "Visitors Provided Their Emails"}
                        className={cn(`bg-white text-gray-700`, !leadsPermission?.can_get_list && "blur-md")}
                        icon={<MailCheck className="size-12" />}
                    />
                </div>
                <div className="col-span-3 md:col-span-2 lg:col-span-1">
                    <StatsCard
                        value={!leadsPermission?.can_get_list ? -1 : 0}
                        title="Abandoned Leads"
                        subtitle={!leadsPermission?.can_get_list ? "No permission to view" : "Visitors Who Didn't Like to Chat"}
                        className={cn(`bg-white text-gray-700`, !leadsPermission?.can_get_list && "blur-md")}
                        icon={<LogOut className="size-12" />}
                    />
                </div>
                <div className="col-span-3 md:col-span-4 lg:col-span-3">
                    <Card className="p-4">
                        <div className="col-span-3 md:col-span-4 lg:col-span-3">
                            <>
                                <LeadsSearchHeader className="mb-4" />
                            </>
                        </div>
                        <LeadsTable setTotalLeads={setTotalLeads} />
                    </Card>
                </div>
            </div>
        </PageWrapper>
    );
};

export default Leads;
